import { useRef } from 'react';
import './SpotlightCard.css';

export const DEFAULT_SPOTLIGHT_COLOR = 'rgba(0, 229, 255, 0.2)';

const SpotlightCard = ({ children, className = '', spotlightColor = DEFAULT_SPOTLIGHT_COLOR }) => {
  const divRef = useRef(null);

  const handleMouseMove = (e) => {
    if (!divRef.current) return;

    const rect = divRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    divRef.current.style.setProperty('--mouse-x', `${x}px`);
    divRef.current.style.setProperty('--mouse-y', `${y}px`);
    divRef.current.style.setProperty('--spotlight-color', spotlightColor);
  };

  return (
    <div ref={divRef} onMouseMove={handleMouseMove} className={`card-spotlight ${className}`}>
      {children}
    </div>
  );
};

export default SpotlightCard;
